import classNames from 'classnames'

import Chat from 'assets/img/feedback/chat.svg?react'
import Like from 'assets/img/feedback/like.svg?react'
import Pen from 'assets/img/feedback/pen.svg?react'
import Phone from 'assets/img/phone.svg?react'
import Resend from 'assets/img/resend.svg?react'
import Arrow from 'assets/img/shared/arrow.svg?react'
import s from './Button.module.scss'

const buttonTypes = {
  special: s.special,
  slav: s.slav,
  info: s.info,
  success: s.success,
  prim: s.prim,
  trip: s.trip,
  promo: s.promo,
}

const icon = {
  like: <Like />,
  pen: <Pen />,
  chat: <Chat />,
  back: <Arrow />,
  phone: <Phone />,
  resend: <Resend />,
}

interface PropsType extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: keyof typeof buttonTypes
  fullWidth?: boolean
  iconType?: 'like' | 'pen' | 'chat' | 'back' | 'phone' | 'resend'
  iconRotate180?: boolean
  iconColor?: 'white'
}

export const Button = ({
  className,
  children,
  iconType,
  buttonType = 'special',
  fullWidth = false,
  disabled = false,
  iconRotate180 = false,
  iconColor,
  ...other
}: PropsType) => {
  const classes = classNames(className, s.button, {
    [s.special]: buttonType === 'special',
    [s.slav]: buttonType === 'slav',
    [s.info]: buttonType === 'info',
    [s.success]: buttonType === 'success',
    [s.prim]: buttonType === 'prim',
    [s.trip]: buttonType === 'trip',
  })

  const iconClasses = classNames(s.icon, {
    [s.iconSlav]: buttonType === 'slav',
    [s.iconRotate180]: iconRotate180,
    [s.iconWhite]: iconColor === 'white',
  })

  return (
    <button className={classes} style={{ width: fullWidth ? '100%' : 'auto' }} disabled={disabled} {...other}>
      {iconType && <span className={iconClasses}>{icon[iconType as keyof typeof icon]}</span>}
      {children}
    </button>
  )
}
